import { ContentWrapper, Heading } from "../../ui"
import ArticlesList from "../../components/articles-list"
import React from "react"
import { HighlightedNewsWrapper } from "./highlighted-news-elements"

interface HighlightedNewsProps {
  data: any
  locale?: string
}

function HighlightedNews ({data, locale}: HighlightedNewsProps) {
  const basePath = `/${locale}/${data.pageSlug}/`
  return <HighlightedNewsWrapper>
    <ContentWrapper>
      <Heading.H4 textTransform="uppercase">
        {data.heading}
      </Heading.H4>
      <ArticlesList
        params={{ locale: locale, count: 3 }}
        basePath={basePath}
        layout="vertical"
        className="bg"
        showExcerpt={false}
      />
    </ContentWrapper>
  </HighlightedNewsWrapper>
}

export default HighlightedNews
